export interface FcfDeepLinkParams {
  qualification: string;
  shiftStart: string;
  cancelledWorkplaceId: string;
}

export const FCF_DEEP_LINK_PARAM_KEYS = {
  qualification: "fcfQualification",
  shiftStart: "fcfShiftStart",
  cancelledWorkplaceId: "fcfCancelledWorkplaceId",
} as const;

export const MAX_FCF_REPLACEMENT_SHIFTS = 5;

export const FCF_SHIFT_RECOMMENDATIONS_DEFAULT_CONFIG = {
  enabled: false,
  leadTimeWindowMinutes: 60,
  distanceMiles: 30,
  startProximityMinutes: 30,
} as const;
